import { render, staticRenderFns } from "./AreasOfConcernSection.vue?vue&type=template&id=24fde774&"
import script from "./AreasOfConcernSection.vue?vue&type=script&lang=js&"
export * from "./AreasOfConcernSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports